import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';
import { PermissionGuard } from './core/guards/permission.guard';
import { AdminShellComponent } from './layout/admin-shell/admin-shell.component';

const routes: Routes = [
  // Public landing page — no guard
  {
    path: '',
    loadChildren: () => import('./features/landing/landing.module').then(m => m.LandingModule),
  },

  // Public login — no guard
  {
    path: 'login',
    loadChildren: () => import('./features/auth/auth.module').then(m => m.AuthModule),
  },

  // Protected admin panel — requires authenticated ADMIN role
  {
    path: 'admin',
    component: AdminShellComponent,
    canActivate: [AuthGuard, PermissionGuard],
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      {
        path: 'dashboard',
        loadChildren: () => import('./features/dashboard/dashboard.module')
          .then(m => m.DashboardModule),
      },
      {
        path: 'users',
        loadChildren: () => import('./features/users/users.module').then(m => m.UsersModule),
      },
      {
        // "Group" is the domain's own word — Group, GroupType, GroupMember,
        // /admin/groups. A group is a family or an organization, and the route
        // saying "families" made an organization sit at a families URL.
        path: 'groups',
        loadChildren: () => import('./features/families/families.module').then(m => m.FamiliesModule),
      },
      // Anyone holding an /admin/families link keeps working. Prefix match, so
      // /admin/families/{id} carries its id across to /admin/groups/{id}.
      { path: 'families', redirectTo: 'groups', pathMatch: 'prefix' },
      // Who is subscribed to what. Distinct from /admin/plans, which is the catalogue.
      {
        path: 'subscriptions',
        loadChildren: () => import('./features/subscriptions/subscriptions.module')
          .then(m => m.SubscriptionsModule),
      },
      // Receipts issued against completed payments. The path is fixed by the
      // backend: AdminDashboard emits /admin/payments as the action path for
      // its invoice_email_failed warning.
      {
        path: 'payments',
        loadChildren: () => import('./features/payments/payments.module')
          .then(m => m.PaymentsModule),
      },
      {
        path: 'plans',
        loadChildren: () => import('./features/plans/plans.module').then(m => m.PlansModule),
      },
      {
        path: 'coupons',
        loadChildren: () => import('./features/coupons/coupons.module').then(m => m.CouponsModule),
      },
      {
        path: 'addons',
        loadChildren: () => import('./features/addons/addons.module')
          .then(m => m.AddOnsModule),
      },
      {
        path: 'app-versions',
        loadChildren: () => import('./features/app-versions/app-versions.module')
          .then(m => m.AppVersionsModule),
      },
      // /admin/roles — no backend support yet
    ],
  },

  { path: '**', redirectTo: '/' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
